import type { ThemeConfig } from 'antd';

/**
 * Ant Design vestito Molti Like.
 *
 * Si parte da una libreria matura invece di riscrivere tabelle, modali e
 * notifiche a mano: quella parte è risolta e collaudata. Qui si cambia
 * solo l'aspetto, così il pannello non sembra un template generico.
 */
export const moltiLikeTheme: ThemeConfig = {
  token: {
    // Gli stessi blu/viola dell'app e delle email
    colorPrimary: '#4F72FF',
    colorInfo:    '#4F72FF',
    colorSuccess: '#0EA26B',
    colorWarning: '#C67C05',
    colorError:   '#DC3055',

    // Neutri con una punta di blu: un grigio puro sembra non scelto
    colorTextBase: '#101527',
    colorBgBase:   '#FFFFFF',
    colorBgLayout: '#F6F7FB',
    colorBorder:          '#E4E7F0',
    colorBorderSecondary: '#EFF1F7',

    borderRadius:    10,
    borderRadiusLG:  14,
    borderRadiusSM:  7,

    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Inter, Roboto, sans-serif",
    fontSize: 14,

    boxShadow:          '0 1px 2px rgba(16,21,39,.05), 0 1px 3px rgba(16,21,39,.04)',
    boxShadowSecondary: '0 4px 14px rgba(16,21,39,.07), 0 1px 3px rgba(16,21,39,.05)',

    controlHeight: 38,
    wireframe: false,
  },

  components: {
    Layout: {
      siderBg:  '#101527',
      headerBg: '#FFFFFF',
      bodyBg:   '#F6F7FB',
      headerHeight: 62,
      headerPadding: '0 26px',
    },
    Menu: {
      darkItemBg:         '#101527',
      darkSubMenuItemBg:  '#101527',
      darkItemColor:      '#C9D1E4',
      darkItemHoverBg:    '#1A2137',
      darkItemHoverColor: '#FFFFFF',
      darkItemSelectedBg: '#4F72FF',
      itemMarginInline: 10,
      itemHeight: 42,
      itemBorderRadius: 9,
    },
    Table: {
      headerBg:        '#FAFBFE',
      headerColor:     '#6B7590',
      headerSplitColor: 'transparent',
      rowHoverBg:      '#F6F7FB',
      cellPaddingBlock: 14,
      borderColor:     '#EFF1F7',
    },
    Card: {
      headerFontSize: 15,
      paddingLG: 22,
    },
    Statistic: {
      contentFontSize: 27,
      titleFontSize: 13,
    },
    Button:   { fontWeight: 600, primaryShadow: 'none' },
    Segmented:{ itemSelectedBg: '#4F72FF', itemSelectedColor: '#FFFFFF' },
    Tag:      { defaultBg: '#EFF1F7' },
  },
};
